import { NavigateFunction } from 'react-router-dom';
import { ROUTES } from '@configs/routes';
import { MAX_REDIRECT_ATTEMPTS } from '../useReturnUrl.constants';
import { isProblematicRoute } from './routeChecking';
import { parseAndValidateUrl } from './urlValidation';
import {
  getStoredReturnUrl,
  getRedirectAttempts,
  incrementRedirectAttempts,
  clearReturnUrlData,
  clearOnlyReturnUrl,
} from './storageManager';

export const handleProblematicRouteNavigation = (
  returnUrl: string,
  navigate: NavigateFunction
): boolean => {
  const currentAttempts = getRedirectAttempts();

  if (currentAttempts >= MAX_REDIRECT_ATTEMPTS) {
    clearReturnUrlData();
    navigate(ROUTES.DASHBOARD.ROOT, { replace: true });
    return true;
  }

  incrementRedirectAttempts(currentAttempts);
  return false;
};

export const handleReturnUrlNavigation = (
  navigate: NavigateFunction
): boolean => {
  try {
    const returnUrl = getStoredReturnUrl();

    if (!returnUrl) {
      navigate(ROUTES.DASHBOARD.ROOT, { replace: true });
      return false;
    }

    const urlObj = parseAndValidateUrl(returnUrl, window.location.origin);

    if (!urlObj) {
      navigate(ROUTES.DASHBOARD.ROOT, { replace: true });
      return false;
    }

    if (isProblematicRoute(returnUrl)) {
      const wasHandled = handleProblematicRouteNavigation(returnUrl, navigate);
      if (wasHandled) {
        return true;
      }
      // For problematic routes that haven't reached max attempts:
      // Clear only the return URL but keep attempts counter
      clearOnlyReturnUrl();
    } else {
      // For non-problematic routes: clear attempts and return URL
      clearReturnUrlData();
    }

    navigate(returnUrl, { replace: true });
    return true;
  } catch (error) {
    console.error('Error handling return URL navigation:', error);
    navigate(ROUTES.DASHBOARD.ROOT, { replace: true });
    return false;
  }
};

export const navigateToFallback = (navigate: NavigateFunction): void => {
  try {
    navigate(ROUTES.DASHBOARD.ROOT, { replace: true });
  } catch (error) {
    console.error('Error navigating to fallback route:', error);
  }
};
